<template>
  <div class="vertical-nav-header d-flex align-center justify-space-between ps-6 pe-5 pt-5 pb-2">
    <router-link
      to="/"
      class="d-flex align-center text-decoration-none"
    >
      <v-img
        :src="appLogo"
        eager
        contain
        class="app-logo me-2"
      ></v-img>

      <v-slide-x-transition>
        <h2
          v-show="!(isVerticalNavMini && !isMouseHovered)"
          class="app-title text--primary"
        >
          {{ appName }}
        </h2>
      </v-slide-x-transition>
    </router-link>

    <v-slide-x-transition>
      <div
        v-show="!(isVerticalNavMini && !isMouseHovered)"
        v-if="$vuetify.breakpoint.lgAndUp"
        class="d-flex align-center ms-1"
        @click.stop="isVerticalNavMini = !isVerticalNavMini"
      >
        <v-icon
          v-show="!isVerticalNavMini"
          size="20"
          class="cursor-pointer"
        >
          {{ icons.mdiPin }}
        </v-icon>
        <v-icon
          v-show="isVerticalNavMini"
          size="20"
          class="cursor-pointer"
        >
          {{ icons.mdiPinOff }}
        </v-icon>
      </div>
      <v-icon
        v-else
        size="20"
        class="d-inline-block"
        @click.stop="$emit('close-nav-menu')"
      >
        {{ icons.mdiClose }}
      </v-icon>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { inject, watch, onMounted } from '@vue/composition-api'
import { mdiClose, mdiPin, mdiPinOff, mdiRadioboxBlank, mdiRecordCircleOutline } from '@mdi/js'
import themeConfig from '@themeConfig'
import useToggleSidebarShortcut from '@/composables/useToggleSidebarShortcut'
import useAppStore from '@/store/app/app'
import { EventBus } from '@/utils/EventBus'

export default {
  setup() {
    const { isVerticalNavMini } = storeToRefs(useAppStore())

    const { wasCtrlBPressed } = useToggleSidebarShortcut()
    watch(wasCtrlBPressed, v => { isVerticalNavMini.value = v })

    onMounted(() => {
      EventBus.$on('close-menu', () => {
        isVerticalNavMini.value = true
      })
    })

    const isMouseHovered = inject('isMouseHovered')

    return {
      isVerticalNavMini,
      isMouseHovered,
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,
      icons: {
        mdiClose,
        mdiRadioboxBlank,
        mdiRecordCircleOutline,
        mdiPin,
        mdiPinOff,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  ;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  background-color: transparent;
  border-radius: 50%;
  width: 30px;
  height: 29px;
  overflow: hidden;
  position: relative;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }

  .img {
  position: absolute;
  bottom: 0;
  width: 100%;
}
}
</style>
